import { ref } from 'vue';
import { useToast } from 'vue-toastification';
import i18n from '@/i18n';
import { generateVariationsData } from '../data/postMessageVariations';
export function useMessageVariations() {
    const toast = useToast();
    const loadingMessages = ref(false);
    const generateVariations = async (baseMessage, numberVariations, closeModal, createActionMessage) => {
        loadingMessages.value = true;
        const params = {
            message: baseMessage,
            quantity: numberVariations,
        };
        await generateVariationsData(params)
            .then(variations => {
            createActionMessage(baseMessage);
            variations.forEach((variation) => createActionMessage(variation));
            toast.success(i18n.global.t('360.campaigns.details.success-messages-toast'), {
                timeout: 4000,
            });
        })
            .catch(() => {
            toast.error(i18n.global.t('360.campaigns.details.error-message-toast'), {
                timeout: 10000,
            });
        })
            .finally(() => {
            closeModal();
            loadingMessages.value = false;
        });
    };
    return {
        loadingMessages,
        generateVariations,
    };
}
